export const baseMappingWithPersonsAndHours = state => {
    return {
        therapists: state.cmk.therapists,
        patients: state.patients.patients,
        therapies: state.cmk.therapies,
        visits: state.cmk.visits,
        plan_hours: state.cmk.plan_hours,
        selectedBaseDate: state.cmk.selectedBaseDate,
        therapists_loaded: state.cmk.therapists_loaded,
        visits_loaded: state.cmk.visits_loaded,
    };
};

export const baseMapping = state => {
    return {
        therapists: state.cmk.therapists,
        patients: state.patients.patients,
    };
};


// WEBPACK FOOTER //
// ./src/store/mappings.js